"use strict";const t=require("./index-66bfd347.js"),e=require("./index-76ec5fb3.js"),r=e.convertToFP(t.format,2);exports.formatDate=r;
